// src/pages/NotFound.tsx
import { AlertTriangle, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-center space-y-6">
      <div className="w-24 h-24 bg-card rounded-full flex items-center justify-center">
        <AlertTriangle className="w-12 h-12 text-yellow-400" />
      </div>
      <div className="space-y-2">
        <h1 className="text-4xl font-bold text-card-foreground">404</h1>
        <h2 className="text-xl font-semibold text-muted-foreground">Página não encontrada</h2>
        <p className="text-muted-foreground max-w-md">
          A página que você está procurando não existe ou foi movida.
        </p>
      </div>
      <Button className="bg-orange-500 hover:bg-orange-600" asChild>
        <Link to="/"><Home className="w-4 h-4 mr-1" /> Voltar ao Início</Link>
      </Button>
    </div>
  );
}